var React = require('react');

function IconLeaf (props) {
    return React.createElement("svg",props,React.createElement("g",{"style":{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeWidth":"4","strokeLinejoin":"round","strokeMiterlimit":"10"}},[React.createElement("path",{"d":"m2 55.63a67.71 67.71 0 0 1 16.11-18.78c24.34-20 58.68-24.75 58.68-24.75s-60.28-35-59.63 25.39","key":0}),React.createElement("path",{"d":"m76.79 12.1s-21.49 51.9-59.53 25.53","key":1}),React.createElement("path",{"d":"m32.56 3.96-2.37 24.46 21.34 13.49","key":2}),React.createElement("path",{"d":"m47.63 2.19-1.4 18.42 17.86 11.11","key":3})]));
}

IconLeaf.defaultProps = {"viewBox":"0 0 78.79 57.63"};

module.exports = IconLeaf;

IconLeaf.default = IconLeaf;
